import React, { useRef, useState }  from 'react';
import emailjs from '@emailjs/browser';
import { Footer } from '../../../../containers';
import { Navbar } from '../../../../components';
import './I-Filosofia-Mas.css';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import 'react-accessible-accordion/dist/fancy-example.css';
import OEFE from '../../../../assets/OEFE.jpg';
import labora from '../../../../assets/labora.jpg';
import edu4schools from '../../../../assets/edu4schools.png';
import ypourgeio from '../../../../assets/ypourgeio.jpg';

const Filosofia = () => {
  const form = useRef();
  const [showSuccess, setShowSuccess] = useState(false);
  const [showError, setShowError] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_ald9cce', 'template_optgjil', form.current, 'EVgIFCLIjxstCs_IK')
      .then((result) => {
          console.log(result.text);
          console.log("message sent");
          e.target.reset();
          setShowSuccess(true);
          setShowError(false);
      }, (error) => {
          console.log(error.text);
          setShowSuccess(false);
          setShowError(true);
      });
  };

  const closePopup = () => {
    setShowSuccess(false);
    setShowError(false);
  };
  return (
    <div className="Filosofia">
        <div className="gradient__bg">
          <Navbar className="navbar" />
        </div>
        <div className="Filosofia__main-container">
          <div className="Filosofia__container">
            <div className="Filosofia__container-h">
              <h1>Η Φιλοσοφία μας</h1>
            </div>
            <div className="Filosofia__container-p">
              <p>&nbsp;&nbsp;&nbsp;Η «Άνοδος», ιδρύθηκε με σκοπό την παροχή υπηρεσιών φροντιστηριακής εκπαίδευσης. Κύρια στοιχεία είναι η καλύτερη οργάνωση, η καλύτερη διαχείριση του ανθρώπινου δυναμικού, η ανάπτυξη νέων παροχών και υπηρεσιών τόσο σε χώρους και εξοπλισμό, όσο και σε προγράμματα σπουδών έτσι ώστε να μπορεί να σταθεί αντάξια στις απαιτήσεις της νέας εποχής.</p>
              <p>&nbsp;&nbsp;&nbsp;Η εταιρεία δραστηριοποιείται στην παροχή υπηρεσιών συμπληρωματικής εκπαίδευσης. Απευθύνεται στους μαθητές του Γυμνασίου και Λυκείου και ιδιαίτερα της τελευταίας τάξης, όπου κυριαρχεί η δοκιμασία των εξετάσεων για το πανεπιστήμιο. Ο ρόλος του φροντιστηρίου έχει τουλάχιστον 2 διαστάσεις, την αμιγώς εκπαιδευτική πλευρά αλλά και την οικονομική και κοινωνική του συνιστώσα.</p>
              <p>&nbsp;&nbsp;&nbsp;Πρώτα η επιθυμία των μαθητών για εισαγωγή στην Τριτοβάθμια Εκπαίδευση. Όσο θα υπάρχουν, και πάντα θα υπάρχουν, σχολές υψηλής ζήτησης και σπουδές που συνδέονται µε επαγγελματική και κοινωνική καταξίωση θα συνυπάρχει και η έννοια του ανταγωνισμού των υποψηφίων για την κατάληψη αυτών των θέσεων, οι οποίες είναι θεαματικά λιγότερες από τους διεκδικητές τους, όπως άλλωστε συμβαίνει σε κάθε ανάλογη πραγματικότητα της κοινωνίας. Γεννιέται λοιπόν η ανάγκη και η επιθυμία των μαθητών και των γονέων τους να αναζητήσουν περαιτέρω εφόδια σε σχέση µε τους υπόλοιπους, να γίνουν δηλαδή ανταγωνιστικοί. Το φροντιστήριο παρέχει αυτήν ακριβώς τη δυνατότητα. Σε καμία περίπτωση δεν υποκαθιστά το σχολείο. Λειτουργεί ενισχυτικά, πολλαπλασιαστικά στις δυνάμεις που το σχολείο δίνει στο μαθητή. Το φροντιστήριο λοιπόν είναι επιλογή.</p>
              <p>&nbsp;&nbsp;&nbsp;Δεύτερη μεγάλη αναγκαιότητα που οδηγεί στα φροντιστήρια είναι οι εγγενείς αδυναμίες πολλών μαθητών να αντεπεξέλθουν στις εκπαιδευτικές απαιτήσεις της σχολικής ζωής. Τα παιδιά αυτά αισθάνονται μειονεκτικά, βιώνουν ανασφάλεια και κλονίζεται σημαντικά η αυτοπεποίθησή τους. Μάλιστα πολλά αντιδρούν αρνητικά µε αποτέλεσμα να υπάρχει αύξηση στους δείκτες της διαρροής μαθητών από τα σχολεία. Και σε αυτήν την περίπτωση, το φροντιστήριο είναι αναγκαιότητα, είναι επιλογή. Παρέχει στους μαθητές οργανωμένη και συστηματική διδασκαλία, εξατομικευμένα προγράμματα σπουδών, σημειώσεις υπό την επιμέλεια των αρμόδιων καθηγητών, επιπλέον ώρες διαγωνισμάτων και γενικά λειτουργεί µε πολύ υψηλές εκπαιδευτικές προδιαγραφές. Ως μέλος της ΟΕΦΕ (Ομοσπονδία Εκπαιδευτικών Φροντιστών Ελλάδας) έχει διαμορφώσει σύστημα διαχείρισης ποιότητας των παρεχόμενων εκπαιδευτικών υπηρεσιών (το γνωστό µας ISO).</p>
              <p>&nbsp;&nbsp;&nbsp;Η κοινωνική και οικονομική συνιστώσα είναι εξίσου σημαντική και αναφέρεται στο σύνολο της Ελληνικής κοινωνίας. Θεωρώντας ως δεδομένη την ανάγκη για εξωσχολική, φροντιστηριακού τύπου, υποστήριξη των μαθητών τότε οι επιλογές είναι δύο. Η µία είναι το φροντιστήριο και η άλλη τα ιδιαίτερα μαθήματα στο σπίτι, αμφιβόλου ποιότητας τις περισσότερες φορές, χωρίς ίχνος ελέγχου και αξιολόγησης. Η λύση των ιδιαιτέρων μαθημάτων κοστίζει στην οικογένεια τουλάχιστον 3-4 φορές περισσότερα από ότι το φροντιστήριο. Με την συμμετοχή στο φροντιστήριο μπορούν όλες οι οικογένειες να προσφέρουν στα παιδιά τους τη δυνατότητα για έναν επί ίσοις όροις ανταγωνισμό. Αυτό σημαίνει πως όλα τα παιδιά μπορούν στην πράξη, όχι θεωρητικά, να παρουσιάσουν ανοδική κοινωνική κινητικότητα. Προσφέροντας υψηλές υπηρεσίες, με κόστος που μπορούν να αντέξουν όλες οι οικογένειες και ποιότητα που ξεπερνάει κάθε άλλη αντίστοιχη διαδικασία. Αυτή η πραγματικότητα ενδυναμώνει την αρχή των ίσων ευκαιριών που αποτελεί αδιαμφισβήτητα προϋπόθεση της κοινωνικής ανάπτυξης. </p>
              <p>&nbsp;&nbsp;&nbsp;Με βάση τα παραπάνω, φροντιστήριο «Άνοδος» σημαίνει:
                  <p>&nbsp;&nbsp;&nbsp;&bull; προοπτική στο μέλλον,</p> 
                  <p>&nbsp;&nbsp;&nbsp;&bull; ανταγωνιστική ποιότητα στην διδασκαλία των μαθημάτων,</p> 
                  <p>&nbsp;&nbsp;&nbsp;&bull; απόλυτη εξειδίκευση σε μαθήματα ειδικής βαρύτητας (όπως είναι τα Μαθηματικά, η Φυσική, η Χημεία, τα Αρχαία, η Έκθεση, η Βιολογία κτλ) </p>
                  <p>&nbsp;&nbsp;&nbsp;&bull; Εξασφάλιση  εισιτηρίου εισόδου στη σχολή που επιθυμεί ο υποψήφιος.</p>
                  <p>&nbsp;&nbsp;&nbsp;&bull; Έλεγχος και αξιολόγηση της παροχής υπηρεσιών του, κάθε χρόνο από τους ίδιους τους μαθητές του αλλά και τους γονείς τους. </p>
              </p>
            </div>
          </div>
            <div className="Filosofia__side-Containers">
              <div className="Filosofia__side-Container1">
                <h1>Χρήσιμες Σελίδες</h1>
                <Accordion allowZeroExpanded allowMultipleExpanded preExpanded={['a']}>
                  <AccordionItem uuid="a">
                    <AccordionItemHeading>
                      <AccordionItemButton>
                        Σημεία Υπεροχής
                      </AccordionItemButton>
                    </AccordionItemHeading>
                      <AccordionItemPanel>
                        <p>
                        Το φροντιστήριο φημίζεται ως  το πιο οργανωμένο και φιλικό προς τους μαθητές του εκπαιδευτήριο. Σε συνδυασμό με την άψογη συνεργασία των καθηγητών του το καθιστά ένα από τα καλύτερα της περιοχής μας.
                        </p>
                        <a href="/Frontistirio/Paroxes-Ypiresiwn/" target="_blank" rel="noopener noreferrer">
                          <button class="custom-btn btn-5">Λεπτομέρειες</button>
                        </a>
                        </AccordionItemPanel>
                  </AccordionItem>
                    <AccordionItem>
                      <AccordionItemHeading>
                        <AccordionItemButton>
                        "Ομάδα ή Μονάδα" ;
                        </AccordionItemButton>
                      </AccordionItemHeading>
                        <AccordionItemPanel>
                          <p>
                          Το παιδί και ο έφηβος μαθαίνουν καλύτερα το «τι» και το «πως» μαζί με τους άλλους. “Learning together, learning to live together”  -UNESCO- 
                          </p>
                          <a href="/OmadaMonada" target="_blank" rel="noopener noreferrer">
                            <button class="custom-btn btn-5">Λεπτομέρειες</button>
                          </a>
                        </AccordionItemPanel>
                    </AccordionItem>
                    <AccordionItem>
                      <AccordionItemHeading>
                        <AccordionItemButton>
                        Πρόταση "ΑΝΟΔΟΥ" για Πανελλήνιες
                        </AccordionItemButton>
                      </AccordionItemHeading>
                        <AccordionItemPanel>
                          <p>
                          Οι υπεύθυνοι σπουδών του  φροντιστηρίου μας, μετά από τόσα χρόνια εμπειρίας είναι ικανοί  να προτείνουν την καλύτερη πρόταση ώστε να επιτύχει ο μαθητής  τον στόχο του.
                          </p>
                          <a href="/Mathimata/B-Lykeiou" target="_blank" rel="noopener noreferrer">
                            <button class="custom-btn btn-5">Λεπτομέρειες</button>
                          </a>
                        </AccordionItemPanel>
                    </AccordionItem>
                    <AccordionItem>
                      <AccordionItemHeading>
                        <AccordionItemButton>
                          Σχόλια Μαθητών
                        </AccordionItemButton>
                      </AccordionItemHeading>
                        <AccordionItemPanel>
                          <p>
                          Οι απόψεις των μαθητών μας για την λειτουργία του φροντιστηρίου αποτελούν κίνητρο για σκληρή και απαιτητική δουλειά, ωστόσο τα θετικά σχόλια είναι η ανταπόδοση όλων των προσπαθειών των καθηγητών μας . 
                          </p>
                          <a href="/PoioiEimaste/Oi-Mathites-Mas/" target="_blank" rel="noopener noreferrer">
                            <button class="custom-btn btn-5">Λεπτομέρειες</button>
                          </a>
                        </AccordionItemPanel>
                    </AccordionItem>
                </Accordion>
              </div>
              <div className="anodos__alykeiou-email-container">
              <form className="anodos__alykeiou-email-container_form" ref={form} onSubmit={sendEmail}>
                <h1 className="anodos__alykeiou-email-container_h1">Φόρμα Επικοινωνίας</h1>
                <label className="anodos__alykeiou-email-container_label">Όνομα</label>
                <input className="anodos__alykeiou-email-container_input" type="text" name="user_name" required/>
                <label className="anodos__alykeiou-email-container_label">Email</label>
                <input className="anodos__alykeiou-email-container_input" type="email" name="user_email" required/>
                <label className="anodos__alykeiou-email-container_label">Μήνυμα</label>
                <textarea className="anodos__alykeiou-email-container_input-message" name="message" required/>
                <input className="anodos__alykeiou-email-container_btn" type="submit" value="Αποστολή" />
              </form>

              {showSuccess && (
                <div className="anodos__alykeiou-email-container_popup anodos__alykeiou-email-container_popup--success">
                  <span>Your message was sent successfully!</span>
                  <button className="anodos__alykeiou-email-container_close" onClick={closePopup}>X</button>
                </div>
              )}

              {showError && (
                <div className="anodos__alykeiou-email-container_popup anodos__alykeiou-email-container_popup--error">
                  <span>There was an error sending your message. Please try again later.</span>
                  <button className="anodos__alykeiou-email-container_close" onClick={closePopup}>X</button>
                </div>
              )}
              </div>
            <div className="anodos__Alykeiou-links-container">
                <a href="https://www.oefe.gr/" target="_blank" rel="noopener noreferrer">
                    <div className="anodos__Alykeiou-links-container_box" style={{ backgroundImage: `url(${OEFE})` }}></div>
                </a>
                <a href="https://labora.gr/" target="_blank" rel="noopener noreferrer">
                    <div className="anodos__Alykeiou-links-container_box" style={{ backgroundImage: `url(${labora})` }}></div>
                </a>
                <a href="https://www.edu4schools.gr/" target="_blank" rel="noopener noreferrer">
                    <div className="anodos__Alykeiou-links-container_box" style={{ backgroundImage: `url(${edu4schools})` }}></div>
                </a>
                <a href="https://www.minedu.gov.gr/" target="_blank" rel="noopener noreferrer">
                    <div className="anodos__Alykeiou-links-container_box" style={{ backgroundImage: `url(${ypourgeio})` }}></div>
                </a>
            </div>
            </div>
          
        </div>
        <Footer />
    </div>
  )
}

export default Filosofia